import React from 'react'
import KnowledgeHubSearch from './search/knowledge-hub'
import { kebabCase } from 'lodash'
import CopyLinkButton from './copy-link-button'
import { KnowledgeHubArticle } from './search/knowledge-hub-search-result'

const searchIndices = [
  { name: `Knowledge Hub Articles`, title: `Knowledge Hub Articles` },
]

export default function KnowledgeHubArchive({ props, location }) {
  const { heading, type, articles, link } = props
  return (
    <>
      {(type !== 'featured' || articles?.length) ? <section className={`kh-archive ${type === "featured" ? "m-section " : "p-section bg-blue-50 kh-search"}`}>
        <div className={`container`}>
          {type === "featured" && articles?.length ? (
            <>
              <div className="group-copy-link group grid grid-cols-1 justify-start">
                {heading ? (
                  <>
                    <h2
                      className="anchor-heading "
                      id={kebabCase(heading).replace(/[0-9]/g, "")}
                    >
                      {heading}
                    </h2>
                    <CopyLinkButton heading={heading} />
                  </>
                ) : props.includeInStickyMenu?.menuTitle ? (
                  <div id={kebabCase(props.includeInStickyMenu.menuTitle) || ""}>
                    <CopyLinkButton heading={props.includeInStickyMenu.menuTitle} />
                  </div>
                ) : null}
              </div>
              <ol className='mt-8 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-12 gap-x-16'>
                {articles.map((article) => {
                  const country = article?.countries?.countries?.length ? article?.countries?.countries[0].name : null
                  const topic = article?.topics?.nodes?.length ? article?.topics?.nodes[0].name : null
                  const sector = article?.sectors?.nodes?.length ? article?.sectors?.nodes[0].name : null
                  return (
                    <li key={article.title}>
                      <KnowledgeHubArticle props={article} country={country} topic={topic} sector={sector} format="featured" />
                    </li>
                  )
                })}
              </ol>
              {link ? (
                <div className="mt-8">
                  <a className="btn btn-blue" href={link.url} target={link.target} rel="noreferrer">
                    {link.title}
                  </a>
                </div>
              ) : null}
            </>
          ) : <KnowledgeHubSearch indices={searchIndices} heading={heading} location={location} />}
        </div>
      </section> : null}
    </>
  )
}
